module.exports = __webpack_public_path__ + "img/tarining4.065dcfd0.jpg";